import React from "react";
import styled from "styled-components";
import { style } from "../style";
import { ResourceCounter } from "./ResourceCounter";
import { ResourceLocation, VPC } from "./types";

export type DisplayOption = {
  value: string;
  title: React.ReactNode;
  disabled: boolean;

  icon?: string;
  group?: string;
  subtitle?: React.ReactNode;
  rightSide?: React.ReactNode;
};

const TitleCityWrapper = styled.span`
  all: unset;
  font-weight: ${style.vars.fontWeight.bold};
`;

const TitleMetaWrapper = styled.span`
  all: unset;
  font-weight: ${style.vars.fontWeight.base};
`;

export const mapResourceLocationToDisplayOption = (resourceLocation: ResourceLocation, mobile: boolean): DisplayOption => {
  const { resources, value, disabled = false, restriction } = resourceLocation;

  let meta: string | undefined;

  if (resourceLocation.type === "datacenter") {
    meta = `Datacenter ${resourceLocation.datacenterId}  •  ${value.toUpperCase()}`;
  }

  const icon = `flag-${resourceLocation.flag}`;

  let title: React.ReactNode;
  let subtitle: string | undefined;

  if (mobile) {
    title = resourceLocation.label;
    subtitle = disabled ? `${value.toUpperCase()} currently unavailable` : meta;
  } else {
    title = (
      <>
        <TitleCityWrapper>{resourceLocation.label}</TitleCityWrapper>
        {meta !== undefined && <TitleMetaWrapper>{`  •  ${meta}`}</TitleMetaWrapper>}
      </>
    );
    subtitle = disabled ? restriction : undefined;
  }

  const rightSide =
    resources.length > 0 ? <ResourceCounter area={resourceLocation.type} resources={resources} disabled={disabled} /> : undefined;

  return {
    title,
    subtitle,
    icon,
    disabled,
    rightSide,
    value,
    group: resourceLocation.continent,
  };
};

export const mapVPCToDisplayOptions = (vpc: VPC): DisplayOption => {
  const { resources, value } = vpc;

  const rightSide = resources.length > 0 ? <ResourceCounter resources={resources} /> : undefined;

  return {
    value,
    title: value,
    disabled: false,
    rightSide,
  };
};
